/**
 * 签证订单类
 */
export default class VisaOrder {
  constructor(order = {}) {
    this.id = order.orderId // (string): 订单id ,
    this.orderId = order.orderId // (string): 订单id ,
    this.orderNo = order.orderNo // (string): 订单号 ,
    this.orderFrom = order.orderFrom // (string): 订单来源 ,
    this.orderFromName = order.orderFromName // (string): 订单来源名称 ,
    this.orderStatus = order.orderStatus // (string): 订单状态码 ,
    this.orderStatusRemark = order.orderStatusRemark // (string): 订单状态说明 ,
    this.inputNo = order.inputNo // (string, optional): 录入号 ,
    this.signOutDate = order.signOutDate // (string, optional): 出签日期 ,
    this.tripDate = order.tripDate // (string): 出行日期 ,
    this.countryName = order.countryName // (string): 国家名称 ,
    this.qzName = order.qzName // (string, optional): 签证名称 ,
    this.areaName = order.areaName // (string): 领区名称 ,
    this.qzTypeName = order.qzTypeName // (string): 签证类型名称 ,
    this.qzForm = order.qzForm // (string): 签证形式 0为电子签 1为贴纸 ,
    this.qzFormName = order.qzFormName // (string): 签证形式名称 ,
    this.expiryDate = order.expiryDate // (string, optional): 有效期 ,
    this.tlqsm = order.tlqsm // (string, optional): 停留期说明 ,
    this.rjcs = order.rjcs // (string, optional): 入境次数 ,
    this.weekDay = order.weekDay // (string, optional): 所需工作日 ,
    this.xsj = order.xsj // (number): 销售价 ,
    this.fwf = order.fwf // (number): 服务费 ,
    this.kdf = order.kdf // (number): 快递费 ,
    this.totalPrice = order.totalPrice // (number): 总价格 ,
    this.addressee = order.addressee // (string, optional): 收件人 ,
    this.addresseePhone = order.addresseePhone // (string, optional): 收件人电话 ,
    this.addresseeSite = order.addresseeSite // (string, optional): 收件地址 ,
    this.expressCompany = order.expressCompany // (string, optional): 快递公司 ,
    this.expressCompanyName = order.expressCompanyName // (string, optional): 快递公司名称 ,
    this.sendBackNumber = order.sendBackNumber // (string, optional): 寄回的快递单号 ,
    this.sendBackExpressCompany = order.sendBackExpressCompany // (string, optional): 寄回的快递公司 ,
    this.sendBackExpressCompanyName = order.sendBackExpressCompanyName // (string, optional): 寄回的快递公司名称 ,
    this.expressNumber = order.expressNumber // (string, optional): 快递单号 ,
    this.kdPayMethod = order. kdPayMethod // (integer, optional): 快递支付方式 1到付 2企业代收 ,
    this.kdPayMethodName = order.kdPayMethodName // (string, optional): 快递支付方式名称 ,
    this.expressRemark = order.expressRemark // (string, optional): 快递单号 ,
    this.tripType = order.tripType // (string): 差旅类型 1因公 2因私 ,
    this.vipStatus = order.vipStatus // (string, optional): 差旅状态 0待审批,1审批中,2审批通过,3审批拒绝,4无需审批 ,
    this.projectName = order.projectName // (string, optional): 出差项目名称 ,
    this.projectCode = order.projectCode // (string, optional): 出差项目编码 ,
    this.projectId = order.projectId // (string, optional): 出差项目Id ,
    this.ccsqdRemark = order. ccsqdRemark // (string, optional): 出差申请备注 ,
    this.costCenterName = order.costCenterName // (string, optional): 成本中心名称 ,
    this.costCenterId = order.costCenterId // (string, optional): 成本中心Id ,
    this.costCenterCode = order.costCenterCode // (string, optional): 成本中心代码 ,
    this.subjectCode = order.subjectCode // (string, optional): 科目码 ,
    this.ifSameOrder = order.ifSameOrder // (string, optional): 企业内部单号是否一致 DY:一致 DN:不一致 ,
    this.linkman = order.linkman // (string, optional): 联系人 ,
    this.linkTel = order.linkTel // (string, optional): 联系号码,// (最多存4个) ,
    this.linkEmail = order.linkEmail // (string, optional): 联系邮箱 ,
    this.appId = order.appId // (string, optional): 审批规则Id ,
    this.gzdm = order.gzdm // (string, optional): 规则代码 ,
    this.gzmc = order.gzmc // (string, optional): 规则名称 ,
    this.ccsqdNo = order.ccsqdNo // (string, optional): 出差申请单号 ,
    this.ccsqdId = order.ccsqdId // (string, optional): 出差申请单ID ,
    this.sendMethod = order.sendMethod // (string, optional): 配送方式 1.邮寄 2市内配送 3公司统一配送 4不需报销票证 ,
    this.recipient = order.recipient // (string, optional): 收件人 ,
    this.reciPhone = order.reciPhone // (string, optional): 收件人电话 ,
    this.reciEmail = order.reciEmail // (string, optional): 收件人邮箱 ,
    this.postCode = order.postCode // (string, optional): 邮政编码 ,
    this.reciAddr = order.reciAddr // (string, optional): 收件地址 ,
    this.postMothed = order.postMothed // (string, optional): 邮寄方式 ,
    this.bookerName = order. bookerName // (string): 企业预订人名称 ,
    this.bookDeptName = order.bookDeptName // (string): 企业预订部门名称 ,
    this.bookDate = order.bookDate // (string): 企业预订时间 ,
    this.sentTime = order.sentTime // (string, optional): 送审时间 ,
    this.sentEmpNo = order.sentEmpNo // (string, optional): 送审人编号/名称 ,
    this.sentDeptName = order.sentDeptName // (string, optional): 送审人所在的部门 ,
    this.payStatus = order.payStatus // (integer): 支付状态 ,
    this.payMothedName = order.payMothedName // (string, optional): 支付方式名称 ,
    this.paySubjectName = order.paySubjectName // (string, optional): 付款科目名称 ,
    this.payDate = order.payDate // (string, optional): 支付日期 ,
    this.payUserName = order.payUserName // (string, optional): 支付人名称 ,
    this.payDeptName = order. payDeptName // (string, optional): 支付部门名称 ,
    this.cgtjUserName = order.cgtjUserName // (string, optional): 采购提交人名称 ,
    this.cgtjDeptName = order.cgtjDeptName // (string, optional): 采购提交人部门名称 ,
    this.cgtjDate = order.cgtjDate // (string, optional): 采购提交人时间 ,
    this.completeUserName = order.completeUserName // (string, optional): 完成人名称 ,
    this.completeDeptName = order.completeDeptName // (string, optional): 完成部门名称 ,
    this.drawDate = order.drawDate // (string, optional): 出票时间 ,
    this.completeDate = order.completeDate // (string, optional): 完成时间 ,
    this.isShowApproval = order.isShowApproval // (string, optional): 是否显示送审操作 ,
    this.isShowPay = order.isShowPay // (string, optional): 是否显示支付操作 ,
    this.isShowCancel = order.isShowCancel // (string, optional): 是否显示取消操作
    this.personList = order.personList ? order.personList.map(psg => new Passenger(psg, order)) : [] // (Array[ObtQzOrderDetailPsgBean], optional): 旅客信息集合 ,
    this.isShowFillSendInfo = order.isShowFillSendInfo
    this.isShowProgress = order.isShowProgress

    // 补充不足的字段
    this.orderType = $dict.ORDER_TYPE.visa // (string, optional) 产品类型
    this.visaName = order.qzName
    this.visaForm = order.qzForm || order.visaForm
    this.visaWeekDay = order.weekDay
    this.immigrationNo = order.rjcs
    this.consularDistrictName = order.areaName
    this.retentionperiod = order.tlqsm
  }
  
  get psgNameStr () {
    return this.personList.map(psg => psg.psgName).join(',')
  }
  
  // 因公因私描述
  get tripTypeStr () {
    return this.tripType == 1 ? '公' : '私'
  }
  
  // 电子签('0')的 不用显示寄回信息  快递费 和补填寄送信息这些
  get showAddress () {
    return this.visaForm !== '0'
  }
  
  // 详细的订单描述
  get orderStatusRemarkDetail () {
    if (this.isShowSs === '1') {
      return '您可先操作送审'
    } else if (this.isShowPay === '1') {
      return '您可先操作支付'
    } {
      return '正在为您排队，加急处理中。。。'
    }
  }
}

export class Passenger {
  /**
   * @param {Object} psg 
   * @param {TrainOrder} order 签证订单信息
   */
  constructor(psg = {}, order) {
    this.psgName = psg.passengerName
    this.psgType = psg.passengerType
    this.phoneNumber = psg.passengerPhone
    this.cardType = psg.idType
    this.passport = psg.idNo
    this.sex = psg.sex 
    this.empNo = psg.empNo
    this.empDeptName = psg.empDeptName

    this.totalPrice = (order.xsj + order.fwf) / order.personList.length
  }
}